import { StateValueHistory } from '../../shared/models';

export const STATE_ITEMS = 'state-items';

export interface StateItemsState {
  states: {
    [key: string]: {
      updates: StateValueHistory[];
      stateHistoryMap: {
        [key: number]: StateValueHistory;
      };
    };
  };
}
